import riot from 'riot';
import events from '../src/events.js';
import { getActivityNotes as libGetActivityNotes, postActivityNotes as libPostActivityNotes } from '../src/lib.js';
riot.tag2('activity-notes', '<article class="message"> <div class="message-header"> <p>Notes</p> </div> <div class="message-body"> <div class="container is-fluid has-text-centered" show="{notesLoading}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="content" if="{activeStepIndex===n.activity_step && notesLoading==false && !notesError}" each="{n,i in notes}"> <textarea class="textarea" id="noteContentInput" placeholder="Add your notes here..." riot-value="{n.content}"></textarea> </div> <div class="content" if="{notesLoading==false && !notesError && !stepHasNotes}"> <textarea class="textarea" id="noteContentInput" placeholder="Add your new notes here..."></textarea> </div> <button class="button is-success" onclick="{saveNotes}">Save Notes</button> </div> </article>', '', '', function(opts) {
        var self = this;
        self.activeStep = self.parent.activeStep;
        self.activeStepIndex = self.parent.activeStepIndex;
        self.selectedActivityRef = self.parent.selectedActivity.activity_ref;
        self.notesLoading = false;
        self.stepHasNotes = false;

        self.on('mount', function() {
            getActivityNotes(self.selectedActivityRef);
            self.stepHasNotes = self.checkStepHasNotes();
        });

        events.on('activity_step_changed', function(step) {
            self.activeStep = self.parent.activeStep;
            self.activeStepIndex = self.parent.activeStepIndex;
            self.stepHasNotes = self.checkStepHasNotes();
            self.update();
        });

        this.checkStepHasNotes = function() {
            console.log("check to see if notes exist for this step: " + self.activeStepIndex)
            if (!self.notes) {
                return false;
            }
            return self.notes.filter(function(n) {
                return n.activity_step === self.activeStepIndex;
            }).length > 0;
        }.bind(this)

        this.saveNotes = function() {
            postActivityNotes(document.getElementById('noteContentInput').value);
        }.bind(this)

        function getActivityNotes(act_ref) {
            self.notesLoading = true;
            self.update();
            libGetActivityNotes(act_ref).then(function(res) {
                self.notesLoading = false;
                self.update({
                    notes: res['data']['notes'],
                    notesError: undefined
                });
                self.stepHasNotes = self.checkStepHasNotes();
            }).catch(function(error) {
                console.error('GET Notes Error:' + error);
                self.notesLoading = false;
                self.update({
                    notes: [],
                    notesError: error
                });
            });
        }

        function postActivityNotes(noteContent) {
            var noteData = {
                activity_ref: self.selectedActivityRef,
                activity_step: self.activeStepIndex,
                content: noteContent
            };
            libPostActivityNotes(noteData).then(function(res) {
                getActivityNotes(self.selectedActivityRef);
            }).catch(function(error) {
                console.error('POST Notes Error:' + error);
            });
        }
});
